var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-builder" },
    [
      _vm.isLoadingAutomation
        ? _c("CompassLoader", {
            staticClass: "automation-builder__loader",
            attrs: { size: "large" }
          })
        : _vm.showAutomation
        ? _c("div", [
            _c("div", {
              staticClass: "automation-builder__container",
              attrs: { id: "builder-app" }
            })
          ])
        : _c(
            "div",
            { staticClass: "automation-builder__empty-state--container" },
            [
              _c("CompassBackForwardButton", {
                staticClass: "automation-builder__empty-state--redirection",
                attrs: {
                  label: _vm.$t.__("common.actions.back"),
                  link: "javascript:history.back();",
                  type: "secondary",
                  back: ""
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "automation-builder__empty-state" },
                [
                  _c("AutomationEmptyStateDisconnectedToProvider", {
                    attrs: { showButton: false }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }